// extracted by mini-css-extract-plugin
module.exports = {"root":"ComingSoon_root__5dVgZ","fullscreen":"ComingSoon_fullscreen__tAen7","image":"ComingSoon_image__jppwH"};